module.exports = __webpack_public_path__ + "static/media/8.fe45ea3e.jpg";